import { useState } from "react";
import { CalendarSync, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Panel } from "@/components/extranet/StatusBadge";
import { http, errMsg } from "@/lib/api";

export default function IcalPanel({ propertyId, rooms, initial, onDone }) {
  const [cfg, setCfg] = useState({ enabled: !!initial?.enabled, feeds: initial?.feeds || {} });
  const [last, setLast] = useState({ at: initial?.last_sync_at, result: initial?.last_result || {} });
  const [busy, setBusy] = useState("");

  const save = async () => {
    setBusy("save");
    try { const r = await http.put(`/extranet/properties/${propertyId}/channel/ical`, cfg); setCfg({ enabled: r.data.enabled, feeds: r.data.feeds || {} }); toast.success("Pengaturan iCal disimpan"); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  const sync = async () => {
    setBusy("sync");
    try {
      await http.put(`/extranet/properties/${propertyId}/channel/ical`, cfg);
      const r = await http.post(`/extranet/properties/${propertyId}/channel/ical/sync`);
      setLast({ at: new Date().toISOString(), result: r.data.result });
      const bad = Object.values(r.data.result).filter((x) => !x.ok).length;
      bad ? toast.error(`${bad} link iCal gagal ditarik, cek log`) : toast.success("iCal berhasil ditarik");
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };

  return (
    <Panel title="iCal (tarik dari channel manager)" testid="ical-panel" className="lg:col-span-2"
      action={<label className="flex items-center gap-2 text-sm font-medium">Aktif <Switch data-testid="ical-enabled" checked={cfg.enabled} onCheckedChange={(v) => setCfg({ ...cfg, enabled: v })} /></label>}>
      <div className="grid gap-4 p-5">
        <p className="text-sm text-slate-600">Tempel link iCal per tipe kamar. Sistem menarik otomatis <b>setiap 15 menit</b>, untuk <b>2 tahun ke depan</b>. Tanggal dengan reservasi di iCal = kamar ditutup di Booking Engine; tanggal kosong tetap dijual. Jika feed berisi harga/kamar (X-PRICE, X-ALLOTMENT), tarif & allotment ikut diperbarui. Jika sebuah link gagal lebih dari 30 menit, email peringatan dikirim ke email konfirmasi hotel (dan email saat pulih).</p>
        {rooms.map((r) => {
          const res = last.result?.[r.id];
          return (
            <div key={r.id} className="grid items-center gap-2 sm:grid-cols-[180px_1fr]">
              <Label className="font-semibold">{r.name}</Label>
              <div>
                <Input data-testid={`ical-url-${r.id}`} value={cfg.feeds[r.id] || ""} placeholder="https://ota.bookandlink.com/utility/icsCal.php?r=...&p=..."
                  onChange={(e) => setCfg({ ...cfg, feeds: { ...cfg.feeds, [r.id]: e.target.value } })} className="font-mono-x text-xs" />
                {res && <p data-testid={`ical-result-${r.id}`} className={`mt-1 text-xs ${res.ok ? "text-emerald-700" : "text-red-600"}`}>
                  {res.ok ? `${res.closed} tanggal ditutup · ${res.priced} tanggal dengan tarif · ${res.reopened} dibuka lagi` : `Gagal: ${res.error}`}</p>}
              </div>
            </div>
          );
        })}
        <div className="flex flex-wrap items-center gap-3">
          <button data-testid="ical-save" onClick={save} disabled={!!busy} className="rounded-md bg-[#1F5F8B] px-5 py-2 font-semibold text-white disabled:opacity-60">Simpan</button>
          <button data-testid="ical-sync-now" onClick={sync} disabled={!!busy} className="flex items-center gap-1.5 rounded-md border border-slate-300 px-4 py-2 text-sm font-semibold hover:bg-slate-50 disabled:opacity-40">
            {busy === "sync" ? <Loader2 className="h-4 w-4 animate-spin" /> : <CalendarSync className="h-4 w-4" />} Simpan & tarik sekarang</button>
          {last.at && <span data-testid="ical-last-sync" className="text-xs text-slate-500">Terakhir ditarik: {new Date(last.at).toLocaleString("id-ID")}</span>}
        </div>
      </div>
    </Panel>
  );
}
